import React from "react";
import { Link } from "react-router-dom";
import "./Footer.styles.css";
import {
  BUSINESS_NAME,
  BUSINESS_TAGLINE,
  EMAIL,
  PHONE_NUMBER,
} from "@/businessInfo/business";

interface FooterProps {
  className?: string;
}

export default function Footer({ className = "" }: FooterProps) {
  const year = new Date().getFullYear();
  const quickLinks = [{ label: "Home", to: "/" }];

  const policyLinks = [
    { label: "Privacy Policy", to: "/privacy-policy" },
    { label: "Terms of Service", to: "/terms-of-service" },
  ];

  return (
    <footer role="contentinfo" className={`footer ${className}`.trim()}>
      <div className="container footer__grid py-16">
        <div className="space-y-4">
          <p className="footer__brand-name">{BUSINESS_NAME}</p>
          {BUSINESS_TAGLINE ? (
            <p className="max-w-sm text-sm text-slate-300">
              {BUSINESS_TAGLINE}
            </p>
          ) : null}
          <div className="space-y-1 text-sm text-slate-300">
            {EMAIL ? <p>{EMAIL}</p> : null}
            {PHONE_NUMBER ? <p>{PHONE_NUMBER}</p> : null}
          </div>
        </div>

        <nav aria-label="Quick links" className="space-y-4">
          <p className="footer__label text-slate-400">Quick links</p>
          <ul className="footer__links space-y-2 text-sm">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Policy links" className="space-y-4">
          <p className="footer__label text-slate-400">Policies</p>
          <ul className="footer__links space-y-2 text-sm">
            {policyLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="footer__meta">
        <div className="container flex flex-col gap-3 py-6 text-sm md:flex-row md:items-center md:justify-between">
          <p>
            © {year} {BUSINESS_NAME}. All rights reserved.
          </p>
          <p>
            Powered by{" "}
            <a
              href="https://www.marketbrewer.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              MarketBrewer
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
